<template>
<div class="tour__holder">
    <div>
        <div class="modal" :class="'aa' + this.id" data-feature="modal" :data-name="`appointment_signup_` + this.id">
            <div class="modal__content" data-feature="modal-active-area">
                <div class="panel">
                    <h3 class="panel__title">{{appointmentTitle}}</h3>
                    <div class="panel__paragraph">{{localAppointmentParagraphComputed}}</div>
                    <div class="panel__paragraph">
                        <button class="tour__button" @click="signUp">{{appointmentButton}}</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" :class="'bb' + this.id" data-feature="modal" :data-name="`appointment_reservelist_signup_` + this.id">
            <div class="modal__content" data-feature="modal-active-area">
                <div class="panel">
                    <h3 class="panel__title">{{appointmentReservelistTitle}}</h3>
                    <div class="panel__paragraph">{{appointmentReservelistParagraph}}</div>
                    <div class="panel__paragraph">
                        <button class="tour__button reservelist__button" @click="signUp">{{appointmentReservelistButton}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <span v-if="isSigned">
            <template v-if="isReserve">
                {{locales.property && locales.property.signed_for_reservelist}}
            </template>

            <template v-else>
                <button class="tour__button cancel__button" @click="signOut">
                  {{locales.appointments && locales.appointments.sign_out}}
                </button>
            </template>
        </span>

        <button v-else class="tour__button" :class="{reservelist__button: isReserve}" data-feature="open-modal" :data-target="target">
            <template v-if="isReserve">
                {{appointmentReservelistListingButton}}
            </template>

            <template v-else>
                {{locales.property && locales.property.sign_up_for_this_viewing}}
            </template>
        </button>
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
import sweetalert from "sweetalert";
export default {
    computed: {
        ...mapGetters(["locales"]),
        target () {
            return this.isReserve ? 'appointment_reservelist_signup_' + this.id : 'appointment_signup_' + this.id
        },
        localAppointmentParagraphComputed () {
            return this.localAppointmentParagraph.replace(":date", this.date).replace(":time", this.time)
        }
    },
    data() {
        return {
            isSigned: this.signed,
            isReserve: this.reserve,
            localAppointmentParagraph: this.appointmentParagraph
        }
    },
    props: {
        id: 0,
        signed: true,
        reserve: false,
        appointmentTitle: {
            default: '',
            type: String
        },
        appointmentParagraph: {
            default: '',
            type: String
        },
        appointmentButton: {
            default: '',
            type: String
        },
        appointmentReservelistTitle: {
            default: '',
            type: String
        },
        appointmentReservelistParagraph: {
            default: '',
            type: String
        },
        appointmentReservelistButton: {
            default: '',
            type: String
        },
        appointmentReservelistListingButton: {
            default: '',
            type: String
        },
        date: {
            default: '',
            type: String
        },
        time: {
            default: '',
            type: String
        },
    },
    methods: {
        signUp () {
            $('.tour__button').attr('disabled',true);
            window.axios.post('/api/appointments/' + this.id + '/sign-up').then((response) => {
                if(response.data.error===undefined){
                    this.isSigned = true;
                    $('.modal').hide();
                    let page = document.getElementById('page');
                    page.classList.remove("z-index");
                    sweetalert(this.locales.common.success, this.locales.appointments.signed_up_message, 'success').then((response) => {
                        var searchUrl = location.search;
                        var urlValue = document.location.href;
                        $('.tour__button').each(function(){
                            $(this).removeAttr('disabled');
                        });
                        if(searchUrl!=''){
                            urlValue = urlValue.replace(searchUrl, '');
                            window.location.href = urlValue;
                        }else{
                          window.location.reload();
                        }
                    });
                }else if(response.data.error=='full'){
                    $('.modal').hide();
                    let page = document.getElementById('page');
                    page.classList.remove("z-index");
                    sweetalert(this.locales.common.error, this.locales.appointments.full_message, 'error').then((response) => {
                        $('.tour__button').each(function(){
                                $(this).removeAttr('disabled');
                            });
                        window.location.reload();
                    });
                }else{
                    $('.modal').hide();
                    let page = document.getElementById('page');
                    page.classList.remove("z-index");
                    sweetalert(this.locales.common.error, response.data.error, 'error').then((response) => {
                        window.location.reload();
                    });
                }            
            }).catch((error)=>{
              if(error.response && (error.response.status == 403 || error.response.status == 401)){
                sweetalert(this.locales.common.error, this.locales.common.login_required, 'error').then(()=>{ window.location.reload() });
              }else{
                sweetalert(this.locales.common.error, this.locales.common.error, "error")
              }
            });
        },
        signOut: function () {
            window.app.sweetalert(this.locales.appointments && this.locales.appointments.are_you_sure_you_want_to_cancel, {
                buttons: ['Cancel', 'Ok'],
            }).then(value => {
                if (value) {
                    window.axios.put('/api/appointments/' + this.id + '/sign-out').then((response) => {
                        window.location.reload();
                    });
                }
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Tour.vue